var __makeTemplateObject =
  (this && this.__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', { value: raw })
    } else {
      cooked.raw = raw
    }
    return cooked
  }
var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i]
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
        }
        return t
      }
    return __assign.apply(this, arguments)
  }
var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {}
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p]
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]]
      }
    return t
  }
import classNames from 'classnames'
import * as React from 'react'
import { Modal } from 'reactstrap'
import styled from 'styled-components'
import { useBorderRadius } from '../../../hooks/useCSSStrings'
export var ODModalTheme
;(function (ODModalTheme) {
  ODModalTheme['Primary'] = 'Primary'
})(ODModalTheme || (ODModalTheme = {}))
export var ODModalSize
;(function (ODModalSize) {
  ODModalSize['Small'] = 'Small'
  ODModalSize['Normal'] = 'Normal'
  ODModalSize['Large'] = 'Large'
  ODModalSize['XLarge'] = 'XLarge'
})(ODModalSize || (ODModalSize = {}))
var CustomModal = styled(Modal)(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      ['\n  border: 0;\n  border-radius: ', ';\n\n  div {\n    border: 0;\n    border-radius: ', ';\n  }\n'],
      ['\n  border: 0;\n  border-radius: ', ';\n\n  div {\n    border: 0;\n    border-radius: ', ';\n  }\n']
    )),
  function (p) {
    return p.border_radius
  },
  function (p) {
    return p.border_radius
  }
)
export var ODModal = function (_a) {
  var children = _a.children,
    props = __rest(_a, ['children'])
  var isOpen = props.isOpen,
    toggle = props.toggle,
    _b = props.fade,
    fade = _b === void 0 ? true : _b,
    _c = props.size,
    size = _c === void 0 ? ODModalSize.Normal : _c,
    _d = props.rounded,
    rounded = _d === void 0 ? false : _d
  var sizeCls = {
    'modal-sm': size === ODModalSize.Small,
    'modal-xl': size === ODModalSize.XLarge,
    'modal-lg': size === ODModalSize.Large,
  }
  var modalProps = {
    border_radius: rounded ? useBorderRadius('normal') : '0',
  }
  return React.createElement(
    CustomModal,
    __assign(
      { fade: fade, isOpen: isOpen, toggle: toggle, className: classNames('modal-primary', 'modal-rect', sizeCls) },
      modalProps
    ),
    React.createElement('div', { style: { display: 'flex', flexDirection: 'column' } }, children)
  )
}
var templateObject_1
//# sourceMappingURL=ODModal.js.map
